import styled from '@emotion/styled';

import ReCaptchaContainer from '../../../../components/ReCaptchaContainer';

export const SignupRecaptchaContainer = styled(ReCaptchaContainer)`
  .grecaptcha-badge {
    display: none;
  }
`;
